import { apiResponseErrorHandler } from 'helpers/common.helper';
import axios from 'axios'

export default {
    


	
    getDashboardStatisticsByCountry(params) {
        return this.handelAlert((res, rej, loadObj) => {
            axios
                .get(`${base}/api/dashboard/statistics`, {
									  params: params,
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
                            }`
                    }
                })
                .then((response) => {
                    res(response.data);
                })
                .catch((rej) => {
                    apiResponseErrorHandler(rej);
                    res(rej.response.data);
                });
        }, false);
    },
    getDashboardContactsByCountry(name) {
        return this.handelAlert((res, rej, loadObj) => {
            axios
                .get(`${base}/api/dashboard/statistics/get-contacts-by-country`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token
                            }`
                    },
                    params: {
                        country: name
                    }
                })
                .then((response) => {
                    res(response.data);
                })
                .catch((rej) => {
                    apiResponseErrorHandler(rej);
                    res(rej.response.data);
                });
        }, false);
    },

    
    
	exportDashboardWidget(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/dashboard/downloads/export-report`, data, {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user')).token || token}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},

	getDashboardFilter() {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.get(`${base}/api/dashboard/filter/get`, {
					headers: {
						Authorization: `Bearer ${
							JSON.parse(localStorage.getItem('user'))?.token || JSON.parse(sessionStorage.getItem('user'))?.token || token
						}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},


}
